import { Tabs } from "antd";
import ChatEditor from "./ChatEditor/ChatEditor";
import KnowledgeEditor from "./KnowledgeEditor/KnowledgeEditor";

const Editor = ({ brand }) => {
  return (
    <div className="h-full overflow-y-scroll">
      <Tabs
        defaultActiveKey="1"
        centered
        items={[
          {
            label: "Chat",
            key: "1",
            children: <ChatEditor brand={brand} />,
          },
          {
            label: "Knowledge",
            key: "2",
            children: <KnowledgeEditor brand={brand} />,
          },
        ]}
      />
    </div>
  );
};

export default Editor;
